import * as React from 'react';
import parse from 'html-react-parser';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkThemeMap } from 'src/common/constants/theme';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export const Messaging: React.FunctionComponent = () => {
  const { offerSummary } = usePropertyListing();

  if (!offerSummary || !offerSummary.messages || offerSummary.messages.length === 0) {
    return null;
  }

  return (
    <div data-stid="content-hotel-primary-messaging">
      {offerSummary.messages.map((offerMessage, index) => {
        const { mark, message, theme } = offerMessage;

        return (
          <UitkSpacing margin={{ blockstart: mark ? 'two' : 'unset' }} key={index}>
            <UitkLayoutFlex>
              <UitkText size={300} theme={UitkThemeMap[theme]}>
                {(mark?.id || mark?.url) && (
                  <UitkSpacing margin={{ inlineend: 'one' }}>
                    <UitkMark name={mark?.url ? null : mark.id} url={mark?.url?.value} size={UitkMarkSize.SMALL} />
                  </UitkSpacing>
                )}
                {message ? parse(message) : null}
              </UitkText>
            </UitkLayoutFlex>
          </UitkSpacing>
        );
      })}
    </div>
  );
};

Messaging.displayName = 'Messaging';
